<template>
    <mySubPage>
        <div slot="header">
            <myNav>{{op=='add'?$t("add_role"):$t("upd_role")}}</myNav>
        </div>
        <el-form class="pd-10" ref="form" :model="formData" :rules="rule" label-width="120px">
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('cat')">
                        <el-select class="fillw" v-model="formData.cat_id" :disabled="op == 'upd'" clearable :placeholder="$t('zdy')">
                            <el-option :label="item.value"  v-for="(item, index) in cats" :value="item.key" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('sort')" prop="sort_id">
                        <el-input v-model="formData.sort_id" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item :label="$t('cname')" prop="role_cname">
                <el-input v-model="formData.role_cname" :placeholder="$t('input')"></el-input>
            </el-form-item>
            <el-row v-if="op == 'upd'">
                <el-col :span="12"><el-form-item :label="$t('add_user')"><el-input v-model="formData.add_user" disabled></el-input></el-form-item></el-col>
                <el-col :span="12"><el-form-item :label="$t('add_time')"><el-input v-model="formData.add_time" disabled></el-input></el-form-item></el-col>
            </el-row>
            <el-row v-if="op == 'upd'">
                <el-col :span="12"><el-form-item :label="$t('upd_user')"><el-input v-model="formData.upd_user" disabled></el-input></el-form-item></el-col>
                <el-col :span="12"><el-form-item :label="$t('upd_time')"><el-input v-model="formData.upd_time" disabled></el-input></el-form-item></el-col>
            </el-row>
        </el-form>
        <div slot="footer">
            <div class="flex-box bg-f8">
                <div class="flex-box-bd"></div>
                <el-button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</el-button>
                <el-button type="primary" @click="submit">{{$t('save')}}</el-button>
            </div>
        </div>
    </mySubPage>
</template>

<script>
    export default {
        data:function(){
            return{
                op: this.$base.getRequest().op,
                relist: false,
                formData: {
                    role_id:'',
                    role_cname: '',
                    sort_id: 99,
                    cat_id: '',
                    add_user:'',
                    add_time:'',
                    upd_user:'',
                    upd_time:'',
                },
                rule: {
                    role_cname: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    sort_id: [{required: true, pattern:this.$base.regNum(), message: this.$t('input'), trigger: 'blur'}],
                },
                cats: [],
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            if(this.op == 'add') {
                this.getLoad();
            }
            else {
                this.formData.role_id = this.$base.getRequest().id;
                this.getInfo();
            }
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            getLoad : function () {
                this.$base.showLoading();
                this.$request.sendPost("role/before-add",{},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.cats = data.cats;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            getInfo: function(){
                var id = this.formData.role_id;
                var data = {
                    role_id: id
                };
                this.$base.showLoading();
                this.$request.sendPost("role/before-upd",data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.formData = this.$base.leftJson(this.formData,data.info);
                        this.cats = data.cats;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            submit: function(){
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        var url = this.op == 'add' ? "role/add" : "role/upd";
                        this.$base.showLoading();
                        this.$request.sendPost(url,this.formData,(success,data,error)=>{
                            this.$base.hideLoading();
                            if(success){
                                this.$base.msgSuccess(error.errmsg);
                                this.relist = true;
                                this.$base.linkBack();
                            }
                            else{
                                this.$base.alertErr(error.errmsg);
                            }
                        });
                    } else {
                        this.$base.alertErr(this.$t('incomplete'));
                    }
                })
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/org/role/role_save.vue